import React from 'react'
import { Form } from 'antd'
import { nameToLabel } from '@/components/AntdForm/utils.ts'

export type AntdFormItemProps = {
  fieldProps: React.ComponentProps<typeof Form.Item> & {
    noCol?: boolean
    span?: number
    noLabel?: boolean
    afterLabel?: React.ReactNode
  }
}

export const AntdFormItem: React.FC<AntdFormItemProps['fieldProps']> = ({ afterLabel, noLabel = false, ...rest }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const label = rest.label == undefined ? nameToLabel(rest.name as any) : rest.label

  return <Form.Item {...rest} label={noLabel ? undefined : <>{label}{afterLabel}</>} />
}